import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'
import { fetchUpshiftApiVaults } from '../../../vaults/upshift/api'

// Monad earnAUSD vault
const EARN_AUSD_VAULT = '0x36eDbF0C834591BFdfCaC0Ef9605528c75c406aA'

const earnAUSD = 'earnAUSD::earnAUSD'

/**
 * earnAUSD intrinsic APR for the global intrinsic map.
 *
 * Reuses the Upshift vault provider's `fetchUpshiftApiVaults` client (the
 * same global listing `vaults/upshift/fetchPublic` parses) and the same
 * `apyToAprPercent` conversion, so this value can't drift from the vault
 * surface. Previously this fetcher re-declared the URL and re-implemented
 * the parse.
 */
export const upshiftFetcher: YieldFetcher = {
  label: 'UPSHIFT',
  fetch: async () => {
    const vaults = await fetchUpshiftApiVaults()
    const vault = vaults.find(
      (v) => String(v?.address).toLowerCase() === EARN_AUSD_VAULT.toLowerCase(),
    )
    const apy = Number(vault?.apy?.apy ?? 0)
    return { [earnAUSD]: apyToAprPercent(apy) }
  },
}
